import React from "react";
import { Box, TextField, Toolbar } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DeadLetterFilters } from "../model/dead-letter";

interface DeadLetterFiltersBarProps {
  filters: DeadLetterFilters;
  onChange: (change: Partial<DeadLetterFilters>) => void;
}

const TEXT_FILTERS: { key: keyof DeadLetterFilters; label: string }[] = [
  { key: "originalTopic", label: "Original topic" },
  { key: "tenantName", label: "Tenant" },
  { key: "eventId", label: "Event ID" },
  { key: "objectId", label: "Object ID" },
  { key: "q", label: "Payload contains" },
];

export const DeadLetterFiltersBar: React.FC<DeadLetterFiltersBarProps> = ({
  filters,
  onChange,
}) => (
  <Toolbar>
    <FilterListIcon />
    <Box display="flex" flexWrap="wrap" gap={1} ml={1} py={1}>
      {TEXT_FILTERS.map(({ key, label }) => (
        <TextField
          key={key}
          size="small"
          label={label}
          value={filters[key]}
          inputProps={{ "data-testid": `filter-${key}` }}
          onChange={(e) => onChange({ [key]: e.target.value })}
        />
      ))}
      <TextField
        size="small"
        type="datetime-local"
        label="From (UTC)"
        value={filters.from}
        InputLabelProps={{ shrink: true }}
        inputProps={{ "data-testid": "filter-from" }}
        onChange={(e) => onChange({ from: e.target.value })}
      />
      <TextField
        size="small"
        type="datetime-local"
        label="To (UTC)"
        value={filters.to}
        InputLabelProps={{ shrink: true }}
        inputProps={{ "data-testid": "filter-to" }}
        onChange={(e) => onChange({ to: e.target.value })}
      />
    </Box>
  </Toolbar>
);
